import { formatCurrency } from 'helpers/formatting';

export default function DataTableCurrencyColumnRender(data) {
  return formatCurrency(data);
}
